import { defineStore } from 'pinia'
import { BasketApi } from '../test-api/index.ts'
import axios from 'axios'
import handleApiError from '../utils/handleApiError'

const basketApi = new BasketApi({}, '/api/v2')
const CancelToken = axios.CancelToken

let cancelationTokens = {}
const state = () => ({
  basket: null,
  productAmounts: {}
})

// functionName: (state, getters, rootState) => {}
const getters = {
  cart() {
    return this.basket
  },
  productAmount(productId) {
    if (!this.basket || !this.productAmounts[productId]) {
      return 0
    }
    return this.productAmounts[productId]
  }
}

// functionName ({ commit, state, dispatch }, param, ...) {}
const actions = {
  async loadCart() {
    const basket = await handleApiError(() => basketApi.basketList())
    this.basket = basket.data
    for (let productKey in this.basket.products) {
      this.productAmounts[this.basket.products[productKey].id] = this.basket.products[productKey].amount
    }
  },
  async remove(productId) {
    const basket = await handleApiError(() => basketApi.basketRemoveProduct(productId))
    this.basket = basket.data
  },
  async addProduct(productId) {
    if (cancelationTokens[productId] !== undefined) {
      cancelationTokens[productId].cancel()
      cancelationTokens[productId] = undefined
    }

    cancelationTokens[productId] = CancelToken.source()
    this.productAmounts[productId] = 1
    const basket = await handleApiError(() => basketApi.basketSetAmount(productId, { amount: this.productAmounts[productId] }, { cancelToken: cancelationTokens[productId].token }))
    this.basket = basket.data
  },
  async substractProduct(productId) {
    if (cancelationTokens[productId] !== undefined) {
      cancelationTokens[productId].cancel()
      cancelationTokens[productId] = undefined
    }

    cancelationTokens[productId] = CancelToken.source()
    this.productAmounts[productId] = - 1
    const basket = await handleApiError(() => basketApi.basketSetAmount(productId, { amount: this.productAmounts[productId] }, { cancelToken: cancelationTokens[productId].token }))
    this.basket = basket.data
  },
  reset() {
    this.basket = null
    this.productAmounts = {}
  }
}

export default defineStore({
  id: 'bcCart',
  state,
  getters,
  actions
})
